import { formatDateToYYYYMMDD } from '@/utils/Date';
import { z } from 'zod';

export const filterSchema = z.object({
  ageFrom: z.number().min(0).optional(),
  ageTo: z.number().min(0).optional(),
  localityIds: z.array(z.number()).optional(),
  state: z.enum(['CANCELLED', 'ACTIVE', 'INACTIVE', 'QUEUED', 'WAITING']).optional(),
  sex: z.enum(['M', 'F', 'O']).optional(),
  date: z.string().optional(),
  type: z.enum(['MONTHLY', 'YEARLY']).default('MONTHLY'),
  workedHoursFrom: z.number().min(0).optional(),
  workedHoursTo: z.number().min(0).optional(),
  priceAmountFrom: z.number().min(0).optional(),
  priceAmountTo: z.number().min(0).optional(),
});

export type Filter = z.infer<typeof filterSchema>;

export const defaultFilter: Filter = {
  ageFrom: undefined,
  ageTo: undefined,
  localityIds: undefined,
  state: undefined,
  sex: undefined,
  date: formatDateToYYYYMMDD(new Date()),
  type: 'MONTHLY',
  workedHoursFrom: 0,
  workedHoursTo: 200,
  priceAmountFrom: undefined,
  priceAmountTo: undefined
};
